import React from 'react';
import { Helmet } from "react-helmet";

const AboutUs = () => {
  return (
    <>
    <Helmet>
  <title>About Us – SomeOne4u</title>
  <meta name="description" content="Get to know the mission behind SomeOne4u – a platform dedicated to building genuine connections worldwide." />
  <meta name="keywords" content="SomeOne4u about us, dating platform mission, global dating community, company story, real love mission" />
  <meta name="author" content="SomeOne4u Team" />
  <meta name="application-name" content="SomeOne4u" />
  <link rel="canonical" href="https://someone4u.com/about-us" />
 
  {/* Open Graph */}
  <meta property="og:title" content="About Us – SomeOne4u" />
  <meta property="og:description" content="Explore how SomeOne4u began and what drives us to connect singles across the globe." />
  <meta property="og:url" content="https://someone4u.com/about-us" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="SomeOne4u" />
  <meta property="og:image" content="https://someone4u.com/image/splash.png" />
 
  {/* Twitter Card */}
  {/* <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="About Us – SomeOne4u" />
  <meta name="twitter:description" content="Discover the vision behind SomeOne4u and our journey in helping people find real love." />
  <meta name="twitter:image" content="https://someone4u.com/image/splash.png" /> */}
</Helmet>

    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f0f0',
        padding: '20px',
        marginBottom: '60px',
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          borderRadius: '10px',
          padding: '40px',
          maxWidth: '800px',
          width: '100%',
        }}
      >
        <h1
          style={{
            textAlign: 'center',
            marginBottom: '30px',
            color: '#333',
            fontSize: '48px',
            fontWeight: 'bold',
          }}
        >
          ABOUT US
        </h1>
        <p>
          Welcome to <strong>SomeOne4u</strong> – a modern matchmaking platform by{' '}
          <strong></strong> built on the belief that love is not just
          an emotion, it’s a journey woven with shared values, meaningful conversations, and mutual
          respect.
        </p>
        <br />
        <p>
          At <strong>SomeOne4u</strong>, we are redefining what it means to find your person in a
          world filled with swipes and superficial connections. We are focused on:
        </p>

        <ul
          style={{
            listStyleType: 'disc',
            paddingLeft: '20px',
            marginTop: '15px',
          }}
        >
          <li>
            <strong>Authentic Profiles:</strong> Every user is carefully verified to ensure you're
            meeting real people with genuine intentions.
          </li>
          <li>
            <strong>Meaningful Matches:</strong> Our smart matching system goes beyond appearance –
            focusing on compatibility, goals, and shared lifestyle values.
          </li>
          <li>
            <strong>Safe Conversations:</strong> Your safety is our priority. We've built features
            that allow you to connect with confidence and clarity.
          </li>
          <li>
            <strong>Inclusive Approach:</strong> SomeOne4u welcomes everyone. Whether you're looking
            for traditional matchmaking or a more modern approach, we provide a space where all
            kinds of love are valid and supported.
          </li>
          <li>
            <strong>Human Support:</strong> We’re not just algorithms. Our team is here to help and
            guide you throughout your journey, making sure your experience is as warm as it is
            efficient.
          </li>
        </ul>
        <br />

        <p>
        SomeOne4u is more than just an app – it's a thoughtful experience for individuals seeking
          meaningful relationships. Built on trust, empathy, and purpose, we’re committed to helping
          you meet someone who truly aligns with your story.
        </p>
        <br />

        <p>
          Whether you're ready to settle down or just beginning your journey toward love, SomeOne4u
          is here to support you. Discover matches that matter. Because at SomeOne4u, your story of
          love is our inspiration.
        </p>
      </div>
    </div>
    </>
  );
};

export default AboutUs;
